import z from 'zod';
import { Currencies } from '.'; // 👈 Usamos el enum global
import { PaymentSnapshotSchema } from './finance/payment-method-schema';
import { AuditSchema } from './settings/audit-schema';

// --- ENUMS DE LÓGICA (Se mantienen, son sólidos) ---

export const TransactionDirectionSchema = z.enum([
  'income', // Dinero que entra al negocio
  'expense', // Dinero que sale (ej: pago de comisión o gastos)
  'debt_created', // Registro de deuda
]);

export const TransactionPurposeSchema = z.enum([
  'advance_payment',
  'sale_balance',
  'full_sale',
  'abono',
  'commission_payout',
  'refund',
  'other_expense',
  'rent_charge',
]);

// --- ESQUEMA PRINCIPAL REFACTORIZADO ---

export const TransactionSchema = z.object({
  professionalId: z.string(),
  businessId: z.string().nullable().optional(),
  clientId: z.string().nullable().optional(),
  clientName: z.string().nullable().optional(),
  saleId: z.string().nullable().optional(),
  appointmentId: z.string().nullable().optional(),
  receivedById: z.string().nullable(),

  direction: TransactionDirectionSchema,
  purpose: TransactionPurposeSchema,

  // 💰 LA VERDAD: Array de snapshots unificados
  payments: z
    .array(PaymentSnapshotSchema)
    .min(1, 'Debe haber al menos un pago'),

  // 🛡️ NORMALIZACIÓN SENIOR
  // La moneda contable del salón en ese momento (USD o EUR)
  accounting_currency: Currencies.default('USD'),

  // El monto total convertido a la moneda contable
  total_amount_accounting: z.number().min(0.01),

  // Tasa de referencia oficial (BCV) del momento exacto
  tasa_at_moment: z.number().min(1),

  // 🇻🇪 RASTRO FÍSICO (Para cuadre de caja en Acarigua)
  // Suma total de lo que entró específicamente en Bolívares
  total_amount_native_bs: z.number().default(0),

  audit: AuditSchema,
});
/**
 * 📥 TransactionInput
 * Lo que envías desde la UI o los servicios al crear una transacción.
 * Omitimos 'audit' porque el TransactionService.prepareCreate lo genera.
 */
export type TransactionInput = Omit<z.infer<typeof TransactionSchema>, 'audit'>;

/**
 * 🧾 Transaction
 * El objeto completo tal cual vive en la base de datos (con auditoría).
 */
export type Transaction = z.infer<typeof TransactionSchema>;

/**
 * 🆔 TransactionWithId
 * Lo que recibes de la base de datos después de un fetch.
 */
export type TransactionWithId = Transaction & { id: string };
